import { render, staticRenderFns } from "./HuaxianProjectGrid.vue?vue&type=template&id=1c032a47&scoped=true&"
import script from "./HuaxianProjectGrid.vue?vue&type=script&lang=js&"
export * from "./HuaxianProjectGrid.vue?vue&type=script&lang=js&"
import style0 from "./HuaxianProjectGrid.vue?vue&type=style&index=0&id=1c032a47&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c032a47",
  null
  
)

export default component.exports